import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil, withLatestFrom, filter, tap } from 'rxjs/operators';
import * as fromComm from 'src/app/modules/communications/store/communications';
import { ConfiguredChannel } from 'src/app/modules/communications/store/communications/communications.model';
import { cloneDeep } from 'lodash-es';
import { GUID_EMPTY } from '@app/core/constants';
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
  selector: 'topo-twilio-tts-edit',
  templateUrl: './twilio-tts-edit.component.html',
  styleUrls: ['./twilio-tts-edit.component.scss'],
  standalone: false
})
export class TwilioTtsEditComponent implements OnInit, OnDestroy {
  @Input() isActive: boolean;
  configuredChannel: ConfiguredChannel;
  destroy$ = new Subject<void>();
  emptyGuid = GUID_EMPTY;

  constructor(
    private store: Store<fromComm.State>,
    private translate: TranslateService,
    private notify: SystemNotificationsService
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromComm.selectTwilioTtsEditIsActive)
      .pipe(takeUntil(this.destroy$))
      .subscribe(isActive => (this.isActive = isActive));

    this.store.dispatch(fromComm.getDefaultConfiguredChannelFromApi());

    combineLatest([
      this.store.select(fromComm.selectSelectedConfiguredChannel),
      this.store.select(fromComm.selectDefaultConfiguredChannel),
      this.store.select(fromComm.selectTwilioTtsEditIsActive)
    ])
      .pipe(
        filter(([, , isActive]) => isActive),
        takeUntil(this.destroy$)
      )
      .subscribe(([selectedChannel, defaultSettings, isActive]) => {
        if (!selectedChannel) {
          this.configuredChannel = null;
          return;
        }

        const cloned = cloneDeep(selectedChannel);

        if (!cloned.settings) {
          cloned.settings = {};
        }

        if (!cloned.settings.phoneNumber && defaultSettings?.phoneNumber) {
          cloned.settings.phoneNumber = defaultSettings.phoneNumber;
        }

        this.configuredChannel = cloned;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.store.dispatch(fromComm.closeConfiguredChannelEdit());
  }

  cancelClick(): void {
    this.close();
  }

  saveClick(): void {
    var regex = /^\+[1-9]\d{1,14}$/;
    if (!regex.test(this.configuredChannel.settings.phoneNumber)) {
      const message = this.translate.instant('MANAGEMENT.COMMUNICATION-CENTER.ERROR-NUMBER-FORMAT');
      this.notify.error(message);
      return;
    }

    this.store.dispatch(fromComm.saveConfiguredChannelToApi({ channel: this.configuredChannel }));
  }
}
